// extracted by css-extract-rspack-plugin
export default {"form":"uWEG6ACHXg0MqRfS","label":"hM2IxfddWrgJOHb6"};